import { Box, Flex, Menu, tabListBehavior } from "@fluentui/react-northstar";
import { mockData } from "../../Assets/data/AIConsumptionData";
import OverviewTab from "./components/Tabs/OverviewTab";
import ExtensionTab from "./components/Tabs/ExtensionTab";
import UserTab from "./components/Tabs/UserTab";
import React, { useEffect } from "react";
import { Card, Tabs } from "antd";
import { useAIConsumption } from "../../context/AIConsumptionContext";
import { useTranslation } from "react-i18next";

const AIConsumption = () => {
  const { aiConsumption, isLoading, getAiConsumption } = useAIConsumption();

  // State for active tab management
  const [activeTabIndex, setActiveTabIndex] = React.useState(0);

  const { t } = useTranslation();

  const translation = t("aiConsumption");

  // Tab items with their labels and content
  const tabs = [
    {
      id: "overview",
      key: translation.tabs.overview,
      content: (
        <OverviewTab
          data={mockData}
          creditUsage={aiConsumption.overview}
          isLoading={isLoading}
        />
      ),
    },
    {
      id: "extension",
      key: translation.tabs.extension,
      content: (
        <ExtensionTab
          data={mockData}
          creditUsage={aiConsumption.byExtension}
          isLoading={isLoading}
        />
      ),
    },
    {
      id: "user",
      key: translation.tabs.user,
      content: (
        <UserTab
          data={mockData}
          creditUsage={aiConsumption.byUser}
          isLoading={isLoading}
        />
      ),
    },
  ];

  useEffect(() => {
    getAiConsumption();
  }, []);

  return (
    <Box
      column
      style={{
        padding: "1rem 2rem",
        margin: "0 auto",
        maxWidth: "1200px",
        width: "100%",
      }}
    >
      {/* Tabs Navigation */}
      <Tabs defaultActiveKey={tabs[0].id}>
        {tabs.map((tab, i) => (
          <Tabs.TabPane tab={tab.key} key={tab.id}>
            <Card
              style={{
                borderRadius: "8px",
                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              }}
              variant="borderless"
            >
              {tab.content}
            </Card>
          </Tabs.TabPane>
        ))}
      </Tabs>
    </Box>
  );
};

export default AIConsumption;
